import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './pages/landing/landing/landing.component'
import { DashboardComponent } from './pages/dashboard/dashboard/dashboard.component';
import { AuditorReportComponent } from './pages/auditor_report/auditor-report/auditor-report.component';
import { FinancialPositionComponent } from './pages/financial_statements/financial-position/financial-position.component';
import { OperatingResultsComponent } from './pages/financial_statements/operating-results/operating-results.component';
import { InitialInterestComponent } from './pages/landing/initial-interest/initial-interest.component';
import { PerformanceSummaryComponent } from './pages/performance_summary/performance-summary/performance-summary.component';
import { LawComponent } from './pages/landing/law/law.component';
import { ManualComponent } from './pages/landing/manual/manual.component';
import { FormComponent } from './pages/landing/form/form.component';
import { InternalDataComponent } from './pages/landing/internal-data/internal-data.component';
import { FinancialstatusReportComponent } from './pages/financialstatus_report/financialstatus-report/financialstatus-report.component';
import { HistoricalDataComponent } from './pages/historical_data/historical-data/historical-data.component';
import { HistoricalCashflowComponent } from './pages/historical-cashflow/historical-cashflow.component'
import { EstimatedRevenueComponent } from './pages/receivables/estimated-revenue/estimated-revenue.component';
import { ReceivableControlComponent } from './pages/receivables/receivable-control/receivable-control.component';
import { ReceivableSummaryComponent } from './pages/receivables/receivable-summary/receivable-summary.component';
import { RevenuePayAccountComponent } from './pages/receivables/revenue-pay-account/revenue-pay-account.component';
import { ReceivableDetailComponent } from './pages/receivables/receivable-detail/receivable-detail.component';
import { AccurateInterestComponent } from './pages/accurate_interest/accurate-interest/accurate-interest.component';
import { AuditByInternalComponent } from './pages/audit_by_Internal/audit-by-internal/audit-by-internal.component';
import { NotFinancialComponent } from './pages/not_financial/not-financial/not-financial.component';
import { CalConditionsComponent } from './pages/cal_conditions/cal-conditions/cal-conditions.component';
import { PlanResultComponent } from './pages/plan/plan-result/plan-result.component';
import { CompareComponent } from './pages/plan/compare/compare.component';
import { TrialBalanceComponent } from './pages/financial_statements/trial-balance/trial-balance.component';
import { DashboardsComponent } from './pages/manager/dashboards/dashboards.component';
import { FinancialStatementsComponent } from './pages/manager/financial-statements/financial-statements.component';
import { MeetingMinutesComponent } from './pages/manager/meeting-minutes/meeting-minutes.component';
import { PerformanceAppraisalComponent } from './pages/manager/performance-appraisal/performance-appraisal.component';
import { ProjectSupportComponent } from './pages/manager/project-support/project-support.component';
import { ProjectViewerComponent } from './pages/manager/project-viewer/project-viewer.component';
import { TakeOffComponent } from './pages/manager/take-off/take-off.component';
import { ResultComponent } from './pages/result/result.component';
import { SettingsComponent } from './pages/settings/settings.component';


const routes: Routes = [
  { path: 'settings', component: SettingsComponent },
  { path: 'landingpage', component: LandingComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'auditorreport/auditorreport', component: AuditorReportComponent },
  { path: 'auditorreport/finencialposition', component: FinancialPositionComponent },
  { path: 'auditorreport/operatingresults', component: OperatingResultsComponent },
  { path: 'landingpage/initialinterest', component: InitialInterestComponent },
  { path: 'performancesummary', component: PerformanceSummaryComponent },
  { path: 'landingpage/law', component: LawComponent },
  { path: 'landingpage/manual', component: ManualComponent },
  { path: 'landingpage/form', component: FormComponent },
  { path: 'landingpage/internaldata', component: InternalDataComponent },
  { path: 'report/financialstatus', component: FinancialstatusReportComponent },
  { path: 'historical/trialbalance', component: HistoricalDataComponent },
  { path: 'historical/cashflow', component: HistoricalCashflowComponent },
  { path: 'receivables/revenue_estimated', component: EstimatedRevenueComponent },
  { path: 'receivables/revenue_payaccount', component: RevenuePayAccountComponent },
  { path: 'receivables/summary', component: ReceivableSummaryComponent },
  { path: 'receivables/control', component: ReceivableControlComponent },
  { path: 'receivables/detail', component: ReceivableDetailComponent },
  { path: 'calculate/accurateinterest', component: AccurateInterestComponent },
  { path: 'auditbyInternal', component: AuditByInternalComponent },
  { path: 'notfinancial', component: NotFinancialComponent },
  { path: 'calconditions', component: CalConditionsComponent },
  { path: 'plan/plan_result', component: PlanResultComponent },
  { path: 'plan/compare', component: CompareComponent },
  { path: 'plan/trialbalance', component: TrialBalanceComponent },
  { path: 'committee/dashboard', component: DashboardsComponent },
  { path: 'committee/financial-statements', component: FinancialStatementsComponent },
  { path: 'committee/meeting-minutes', component: MeetingMinutesComponent },
  { path: 'committee/performance-appraisal', component: PerformanceAppraisalComponent },
  { path: 'committee/project-support', component: ProjectSupportComponent },
  { path: 'committee/project-viewer/:id', component: ProjectViewerComponent },
  { path: 'committee/personnel', component: TakeOffComponent },
  { path: 'committee/auditbyInternal', component: AuditByInternalComponent },
  { path: 'committee/result', component: ResultComponent },
  { path: '', redirectTo: '/landingpage', pathMatch: 'full' },
  { path: '**', redirectTo: '/landingpage', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
